// src/webideal-recruit/components/dashboard/PipelineChart.jsx
import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function PipelineChart({ applications }) {
  const stages = ["new", "screening", "interview", "technical", "offer", "hired"];

  const counts = stages.map((stage) =>
    applications.filter((a) => a.stage?.toLowerCase() === stage).length
  );

  const chartData = {
    labels: ["New", "Screening", "Interview", "Technical", "Offer", "Hired"],
    datasets: [
      {
        label: "",
        data: counts,
        backgroundColor: [
          "#3b82f6",
          "#f59e0b",
          "#8b5cf6",
          "#6366f1",
          "#10b981",
          "#22c55e",
        ],
        borderRadius: 6,
        barThickness: 22,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: {
        beginAtZero: true,
        grid: { display: false },
      },
      y: {
        grid: { display: false },
      },
    },
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm h-[340px]">
      <h3 className="text-lg font-semibold text-slate-900 mb-4">
        Hiring Pipeline
      </h3>
      <Bar data={chartData} options={options} />
    </div>
  );
}
